import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import IErrorResolver from "@models/IErrorResolver.model";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.scss"],
})
export class ErrorComponent implements OnInit {
  constructor(public router: Router, public activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const data: IErrorResolver = this.activatedRoute.snapshot.data["errorData"];
    console.log("data", data);

    try {
      const link = document.querySelector(".language-selector a") as HTMLAnchorElement;
      if (link) {
        link.href = `${window.location}#`;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
